/*
 * @Author: w
 * @Date: 2022-03-31 18:09:27
 * @LastEditors: w
 * @LastEditTime: 2022-04-03 14:09:24
 */
// export { useInfoStore } from "./login";
import { createPinia } from 'pinia'

const store = createPinia()

export default store